<script setup lang="ts">
import { onMounted, ref } from 'vue';

import type { Organization } from '@/types/organization';

import List from '@/components/List.vue';
import { useOrganizationStore } from '@/stores/organization';
import { useRouter } from 'vue-router';
import type { DataTableHeader } from 'vuetify';

const organizationStore = useOrganizationStore();

const router = useRouter();

const organizations = ref<Organization[]>([]);
const isInitializing = ref(true);

onMounted(async () => {
    organizations.value = await organizationStore.get();
    isInitializing.value = false;
});

const tableHeaders: DataTableHeader[] = [{ title: 'Naam', value: 'name', sortable: true }];

async function clickDeleteOrganization(item: Organization) {
    await organizationStore.deleteOrganization(item._id);
    organizations.value = organizations.value.filter((org) => org._id !== item._id);
}

async function clickEditOrganization(item: Organization) {
    await router.push(`/bedrijf-bewerken/${item?._id}`);
}

async function clickCreate() {
    await router.push(`/bedrijf-maken`);
}

function openOrgDetails(organization: Organization) {
    router.push(`/bedrijf/${organization._id}/informatie`);
}
</script>

<template>
    <div>
        <List
            entityName="Bedrijf"
            :headers="tableHeaders"
            :items="organizations"
            :isEditable="true"
            :isDeletable="true"
            :createButtonCallback="clickCreate"
            @clickTableRow="(item) => openOrgDetails(item)"
            @clickTableRowEdit="(item) => clickEditOrganization(item)"
            @deleteConfirmed="(item) => clickDeleteOrganization(item)"
            :isInitializing="isInitializing"
        >
            <template v-slot:item.name="{ item }">
                <router-link
                    :to="`/bedrijf/${item._id}/informatie`"
                    class="d-flex align-center ga-1 text-black text-decoration-none hover-main pa-1 rounded-lg"
                >
                    <v-icon icon="business" class="text-main" />
                    <span class="text-main font-weight-medium">{{ (item as any).name }}</span>
                </router-link>
            </template>
        </List>
    </div>
</template>
